import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";

import SwitchToggle from "../../components/SwitchToggle";

const UserList = () => {
  const navigate = useNavigate();

  const users = [
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      phone: "+91 9876543210",
      subscription: "Monthly",
      workoutsCompleted: 42,
      createdAt: "2024-01-12",
    },
    {
      id: 2,
      name: "Sarah Smith",
      email: "sarah@example.com",
      phone: "+91 9988776655",
      subscription: "Yearly",
      workoutsCompleted: 120,
      createdAt: "2024-02-01",
    },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User Detail</TableCell>
              <TableCell>Subscription</TableCell>
              <TableCell>Workouts Completed</TableCell>
              <TableCell>Onboard Date</TableCell>
              <TableCell>Enable / Disable</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map((user) => (
              <TableRow hover key={user.id}>
                {/* USER DETAILS */}
                <TableCell className="click_action">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail", { state: { user } });
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="User"
                      />
                    </figure>

                    <p>
                      <b>{user.name}</b>
                      <span>{user.phone}</span>
                      <span>{user.email}</span>
                    </p>
                  </a>
                </TableCell>

                {/* SUBSCRIPTION */}
                <TableCell>{user.subscription}</TableCell>

                {/* WORKOUT COUNT */}
                <TableCell>{user.workoutsCompleted}</TableCell>

                {/* ONBOARD DATE */}
                <TableCell>{user.createdAt}</TableCell>

                {/* ENABLE / DISABLE */}
                <TableCell>
                  <SwitchToggle />
                </TableCell>

                {/* ACTION BUTTONS */}
                <TableCell>
                  <div className="table_actions v2">
                    <IconButton
                      onClick={() =>
                        navigate("/manage-users/detail", { state: { user } })
                      }
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                    <IconButton
                      onClick={() =>
                        navigate("/manage-users/add", { state: { user } })
                      }
                    >
                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                    </IconButton>

                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default UserList;
